<template>
  <div class="login-wrapper">

    <div class="login">

      <img src="/static/img/suez-white.png" class="logo"/>

      <h2>Les cantonniers, SUEZ</h2>
      <h3>Back Office</h3>

      <!-- login form -->
      <form @submit.prevent="submit()">
        <div class="ui form loginForm">
          <div class="input-group">
            <input class="form-control" name="username" placeholder="Login" type="text" v-model="username" required>
          </div>

          <div class="input-group">
            <input class="form-control" name="password" placeholder="Mot de passe" type="password" v-model="password"
                   required>
          </div>

          <div class="input-group checkbox">
            <label>
              <input type="checkbox" v-model="rememberMe">Se souvenir de moi
            </label>
          </div>

          <div v-if="login.message !== null"
               v-bind:class="'callout callout-'+login.message.type">
            <p>{{ login.message.text }}</p>
          </div>

          <div v-if="login.loggedIn"
               class="callout callout-success">
            <p>Bienvenue !</p>
          </div>
        </div>
        <a href="#" v-on:click="forgotPassword"> > Mot de passe oublié ? </a>
        <button class="btn btn-primary btn-lg">S'authentifier</button>
      </form>
      <a @click="handleButtonClick" class="transparent-button">
        Politique de confidentialité
      </a>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import jwt from "jsonwebtoken"
import api from '../store/api'

export default {
  name: 'Login',
  computed: {
    ...mapState([
      'login',
    ]),
  },
  data () {
    return {
      username: '',
      password: '',
      rememberMe: false,
      jwtToken: '', // Replace with the actual JWT token
      tokenUsername: '',
      tokenExpirationDate: ''
    }
  },
  mounted () {
    //this.$store.dispatch('fetchAllVilles')

    let token = localStorage.getItem('TOKEN')
    let rememberMe = localStorage.getItem('REMEMBER')
    this.jwtToken = token
    this.decodeToken();

    if (token && rememberMe !== 'false') {
      this.$store.dispatch('loginWithToken',{
        login: this.tokenUsername
      })
    }

  },
  methods: {
    handleButtonClick() {
      console.log('Button clicked!');
      this.$router.push('/rgpd');
    },
    submit () {

      this.$store.dispatch('login', {
        login: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
      })

      console.log('LoggedIn => ' , this.login.loggedIn)
    },
    forgotPassword: function () {
      this.$store.dispatch('forgotPassword', this.username)
    },
    decodeToken() {
      try {
        console.log("decode")
        const decodedToken = jwt.decode(this.jwtToken);

        if (decodedToken) {
          this.tokenUsername = decodedToken.sub;
          this.tokenExpirationDate = new Date(decodedToken.exp * 1000);
        }
      } catch (error) {
        console.error("Error decoding JWT token:", error);
      }
    },
  },
  updated () {
    if (this.$store.state.login.loggedIn) {
      if (this.$route && this.$route.query && this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
        console.log("this.$route.query.redirect => " , this.$route.query.redirect)
      } else {
        this.$router.push('/')
      }
    }
  },
}
</script>

<style lang="scss">
@import '../scss/variables';

.login-wrapper {
  background: url("../../static/img/bg-img.jpg") no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .login {
    text-align: center;
    width: 350px;

    .logo {
      max-width: 300px;
      padding: 0;
      margin: 0 auto;
      display: block;
      margin-bottom: 3rem;
    }

    h2, h3 {
      text-align: center;
      margin: 0;
    }

    h3 {
      color: $suez-steel;
    }

    h2 {
      color: $suez-white;
    }

    .loginForm {
      margin-top: 3rem;
      background-color: $suez-grey;
      padding: 10% 10% 5% 10%;

      .checkbox {
        text-align: left;

        label {
          color: $suez-steel;
        }
      }

      .input-group {
        width: 80%;
        margin: auto;
        margin-bottom: 15px;

        .form-control {
          border: none;
          border-radius: 5px;
          height: 44px;
        }
      }

      .input-group-addon {
        width: 40px;
      }
    }

    button {
      margin: 0 auto;
      margin-top: 3rem;
      display: block;
      font-weight: 600;
      font-size: 1.4rem;

      &.loading {
        opacity: 0.4;
        pointer-events: none;
      }
    }

    a {
      display: block;
      color: $suez-steel;
      text-align: right;
      margin-top: 10px;
      font-weight: 600;
    }
  }
}
.transparent-button {
  margin-top: 10%!important;
  color: white!important;
  background-color: transparent;
  text-decoration: none;
  text-align-last: center;
  cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// Login.vue?9b8c62c6